import { j as t } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as x } from "react";
import { c as f } from "./tw-cn-mXgPecoF.mjs";
import { T as v } from "./text-button-CzR6iE2X.mjs";
import { c as a } from "./index-BpNK5r1N.mjs";
const b = a(["fixed w-full pointer-events-none"], {
  variants: {
    active: {
      true: "",
      false: ""
    },
    position: {
      bottom: "mx-auto left-1/2 bottom-0",
      top: "mx-auto left-1/2 top-20",
      center: "mx-auto left-1/2 top-1/2"
    }
  },
  compoundVariants: [
    // bottom과 top은 같은 애니메이션 사용
    {
      active: !0,
      position: ["bottom", "top"],
      className: "animate-toastFadeIn"
    },
    {
      active: !1,
      position: ["bottom", "top"],
      className: "animate-toastFadeOut"
    },
    // center는 별도의 opacity 애니메이션 사용
    {
      active: !0,
      position: "center",
      className: "animate-toastCenterFadeIn"
    },
    {
      active: !1,
      position: "center",
      className: "animate-toastCenterFadeOut"
    }
  ]
}), h = a(
  ["inline-flex max-w-[320px] pc:max-w-[343px]", "bg-fill-neutral-main", "px-20 mb-20", "pointer-events-auto"],
  {
    variants: {
      radius: {
        "rounded-4": "rounded-4",
        "rounded-6": "rounded-6",
        "rounded-8": "rounded-8"
      },
      position: {
        bottom: "-translate-x-1/2",
        top: "-translate-x-1/2",
        center: "-translate-x-1/2 -translate-y-1/2"
      },
      hasTextButton: {
        true: "items-center gap-20 justify-between w-[calc(100%-32px)] max-w-none pc:w-[343px]",
        false: "text-center"
      },
      defaultVariants: {
        hasTextButton: !1
      }
    }
  }
), y = a([
  "text-static-white whitespace-pre-line",
  "typography-body-14-regular break-words line-clamp-2",
  "cursor-default select-none"
]), w = x(
  ({
    active: n,
    children: r,
    radius: o = "rounded-8",
    bottomOffset: i = 0,
    position: s = "bottom",
    textButton: e,
    onAnimationEnd: l = () => {
    },
    zIndex: c
  }, m) => {
    const p = b({ active: n, position: s }), d = h({ radius: o, position: s, hasTextButton: !!e }), u = y({});
    return /* @__PURE__ */ t.jsx(
      "div",
      {
        className: p,
        onAnimationEnd: l,
        ref: m,
        style: { paddingBottom: `calc(env(safe-area-inset-bottom) + ${i})`, zIndex: c },
        children: /* @__PURE__ */ t.jsxs("div", { className: f([d, o]), children: [
          /* @__PURE__ */ t.jsx("div", { className: "py-12", children: /* @__PURE__ */ t.jsx("span", { className: u, children: r }) }),
          !!e && /* @__PURE__ */ t.jsx(
            v,
            {
              className: "my-8 shrink-0",
              mobileSize: "small",
              onClick: e.onClick,
              pcSize: "small",
              theme: "underline",
              transparent: !0,
              children: e.text
            }
          )
        ] })
      }
    );
  }
);
w.displayName = "NDS.Toast";
export {
  w as T
};
